import React, { Component } from "react";
import axios from "axios";
import { Footerhome } from "../../components/footerhome/Footerhome";
import Util from "../../util/util";

import "./FrequentQuestions.css";

class FrequentQuestions extends Component {
  constructor() {
    super();
    this.state = {
      faq_sections: [],
    };
  }

  componentDidMount() {
    document.title = this.props.pageTitle;

    var ret = Util.storagePreload(["faq_list"], "json", [], false);
    this.setState({ faq_sections: ret["faq_list"] });

    var mainThis = this;
    axios
      .get(window.ajaxLink + "user/faq")
      .then((res) => {
        if (
          res["data"] &&
          res["data"]["responseData"] &&
          res["data"]["responseData"]["faqsections"]
        ) {
          localStorage.setItem(
            "faq_list",
            JSON.stringify(res["data"]["responseData"]["faqsections"])
          );
          mainThis.setState({
            faq_sections: res["data"]["responseData"]["faqsections"],
          });
        }
      })
      .catch((err) => {});
  }

  sectionFocus = (i) => {
    var elementTop = document.getElementById("Section" + i).offsetTop;

    if (window["timerScroll"]) {
      clearInterval(window["timerScroll"]);
    }
    window["timerScroll"] = setInterval(() => {
      if (window.scrollY < elementTop - 70 * (i + 1) - 11) {
        window.scrollTo(0, window.scrollY + 70 * (i + 1));
      } else {
        window.scrollTo(0, elementTop - 10);
        clearInterval(window["timerScroll"]);
      }
    }, 100);
  };

  openAnswer = (j, k) => {
    var faqSections = this.state.faq_sections;

    if (faqSections[j].questions[k].answer_height == 0) {
      faqSections[j].questions[k].answer_height = document.querySelector(
        "#Answer" + k
      ).clientHeight;
    } else {
      faqSections[j].questions[k].answer_height = 0;
    }

    this.setState({ faq_sections: faqSections });
  };

  render() {
    return (
      <div className="frequent_questions_page">
        <div className="frequent_questions_page_title">
          Često postavljena pitanja
        </div>
        <div className="frequent_questions_subject_container">
          {this.state.faq_sections.map((oneSection, i) => (
            <div
              key={i}
              className="frequent_questions_subject_box"
              onClick={() => this.sectionFocus(i)}
            >
              <div className="frequent_questions_subject_box_text">
                {oneSection.section_name}
              </div>
            </div>
          ))}
        </div>
        <div className="frequent_questions_subject_bar">
          {this.state.faq_sections.map((oneSection, j) => (
            <div
              key={j}
              tabIndex={j}
              className="frequent_questions_single_subject"
            >
              <div
                className="frequent_questions_subject_title"
                id={"Section" + j}
              >
                {oneSection.section_name}
              </div>
              {oneSection.questions.map((oneQuestion, k) => (
                <div key={k} className="frequent_questions_box">
                  <div
                    className={
                      "frequent_questions_subject_question" +
                      (oneQuestion.answer_height
                        ? " subject_question_active"
                        : "")
                    }
                    onClick={() => this.openAnswer(j, k)}
                  >
                    {oneQuestion.question}
                  </div>
                  <div
                    className="frequent_questions_answer_wrapper"
                    style={{ height: oneQuestion.answer_height + "px" }}
                  >
                    <div
                      id={"Answer" + k}
                      className="frequent_questions_subject_answer"
                    >
                      {oneQuestion.answer}
                    </div>
                  </div>
                </div>
              ))}
            </div>
          ))}
        </div>

        <Footerhome></Footerhome>
      </div>
    );
  }
}

export default FrequentQuestions;
